import { render, staticRenderFns } from "./Snappay.vue?vue&type=template&id=0f07afc4&"
import script from "./Snappay.vue?vue&type=script&lang=js&"
export * from "./Snappay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports